import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './Sections/Navbar';
import Footer_site from './Sections/Footer_site';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <Router>
<Navbar/>
  <App />
<Footer_site/>
</Router>
  
  </>
  
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
